import RewardsBanner from './RewardsBannerContainer';
export default RewardsBanner;
